import { render, staticRenderFns } from "./Cedes.vue?vue&type=template&id=0ede4b48&"
import script from "./Cedes.vue?vue&type=script&lang=js&"
export * from "./Cedes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports